import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div className='container mx-auto bg-green-100 px-6 md:px-16 lg:px-24 pt-8 pb-16'>
            {/* Title */}
            <h1 className='text-4xl font-extrabold text-secondary text-center mb-6'>ABOUT US</h1>

            {/* Description */}
            <p className='text-lg leading-relaxed text-gray-700 text-justify'>
                Rajshahi University Affiliated Engineering College, Code: 385 Imperial College of Engineering got approval for affiliation 
                on 18th October 2017 from a famous public university of The governing-body. ICE is a gateway to get an international-quality 
                public university degree to be a skilled and qualified engineer. As the education quality will be verified and evaluated by 
                a public university and finally they will provide the certification, the value of the degree will be better than any other private university.
            </p>

            {/* Centered Button */}
            <div className='mt-8 flex justify-center'>
                <Link to="/about-us">
                    <button className='px-6 py-3 text-lg font-semibold text-white bg-primary rounded-full transition-transform duration-300 hover:scale-105 hover:bg-opacity-90'>
                        Learn More
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default About;
